import { render, staticRenderFns } from "./proposalHistory.vue?vue&type=template&id=5624c63e&scoped=true"
import script from "./proposalHistory.vue?vue&type=script&lang=js"
export * from "./proposalHistory.vue?vue&type=script&lang=js"
import style0 from "./proposalHistory.vue?vue&type=style&index=0&id=5624c63e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624c63e",
  null
  
)

export default component.exports